import { render, staticRenderFns } from "./store_page.vue?vue&type=template&id=5da2f82a&"
import script from "./store_page.vue?vue&type=script&lang=js&"
export * from "./store_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports